import { createSelector } from 'reselect';
import { alertModel } from '../../../models/core/alert.model';
import { errorModel } from '../../../models/service/error.model';
import { getMinDate, getMaxDate, combineErrorsAndAlerts } from './alerts.helper';
import { getCurrentDate } from '../../service/settings.selectors';
import { GLOBAL_TYPES } from '../../../device/types/global.types';
import { tstToDate, dateToTst } from '../../../utils/helpers';

export const errors = state => state.error[errorModel.MODEL_NAME];
export const alerts = state => state.alert[alertModel.MODEL_NAME];

export const getDetails = (state, lastItemsCount) => {
    const errors = state.error[errorModel.MODEL_NAME];
    const alerts = state.alert[alertModel.MODEL_NAME];
    return combineErrorsAndAlerts(errors, alerts, lastItemsCount);
};

export const getDetailsMaxDate = (state, lastItemsCount) => {
    const currentDate = getCurrentDate(state);
    const detailsObj = getDetails(state, lastItemsCount);
    const { details } = detailsObj;
    const { storage } = details;
    let maxDate = getMaxDate(currentDate, details);

    if (storage) {
        const data = storage[GLOBAL_TYPES.ALERTS];
        if (data && data.intervals.length) {
            const maxDateRaw = Math.max(data.intervals[0].maxDate.dateRaw, dateToTst(maxDate));
            maxDate = tstToDate(maxDateRaw);
        }
    }

    return maxDate;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/alerts/alert.selectors.js